import { render, staticRenderFns } from "./contract-history.vue?vue&type=template&id=194a52fc&scoped=true&"
import script from "./contract-history.vue?vue&type=script&lang=js&"
export * from "./contract-history.vue?vue&type=script&lang=js&"
import style0 from "./contract-history.vue?vue&type=style&index=0&id=194a52fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a52fc",
  null
  
)

export default component.exports